// ABOUTME: Progression modal for adding a new external channel integration
// ABOUTME: 3-step wizard: Choose type -> Basic info + API key -> Configuration (sync settings)

import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal"
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper"
import ChooseChannelType from "./views/ChooseChannelType"
import ChannelBasicInfo from "./views/ChannelBasicInfo"
import ChannelConfiguration from "./views/ChannelConfiguration"
import { useCreateExternalChannelMutation } from "../../../../newapi/externalchannel/externalChannelSlice"

const MpAddExternalChannel = (props) => {
    const { t } = useTranslation();
    const channelType = useSelector((state) => state.progressiontabs.data?.channel_type);

    const onSave = (response) => {
        props.handleClose();
        // An outlook channel still needs its mailbox connected through OAuth from its
        // sidepanel before it does anything, so land the user there. Every other channel
        // is complete once saved.
        const createdChannelId = response?.data?.id;
        if (channelType === 'outlook' && createdChannelId) {
            props.onOpenCreatedChannel?.(createdChannelId);
        }
    }

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useCreateExternalChannelMutation} isModal title={t("add_external_channel")}>
                <ChooseChannelType />
                <ChannelBasicInfo />
                <ChannelConfiguration />
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpAddExternalChannel;
